import { $, $$ } from '../../lib/dom';

/** Swaps the video poster for the YouTube (privacy-enhanced) player only when the visitor presses play. */
export function initVideo(root: HTMLElement): void {
  $$('[data-video]', root).forEach((container) => {
    const videoId = container.dataset.video ?? '';
    $('.video-play', container)?.addEventListener('click', () => {
      container.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0" title="ReTax360 platform overview" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    });
  });
}
